import React, {Fragment, useEffect, useState} from 'react';
import RendererEngine from "./RendererEngine";
import {PracticeFrontNode, SEOItems} from "../typings/interfaces/practice-front-node.interface";
import {useQuery} from "react-query";
import PageLoader from '../components/PageLoader';
import PageError from '../components/PageError';
import ThemeStore from "../stores/theme-store";
import {QUERY_NAMES} from "../apiManager/queryNames";
import { getPracticeFrontByDomain, getPracticeFrontByDomainStage } from '../apiManager/practiceFrontsApis/practiceFront';
import Head from '../components/Head';

function getSubdomain(domain:any){
    // @ts-ignore
   const host= /:\/\/([^/]+)/.exec(domain)[1]
    return  host.split('.')[0]
}

const defaultSeo:SEOItems={
    siteDescription: "Website",
    siteFavIcon:'/public/corgi.png',
    siteKeywords: 'DocSpace,website',
    siteTitle:"DocSpace",
}

const AppContainer:React.FC =()=> {
    let subdomain:string | null;
    subdomain= getSubdomain(window.location.href)
    const [seoSettings,setSeoSettings]=useState<SEOItems>(defaultSeo);
    const [subDomainStage,setSubDomainStage]= useState<string | null>(null)
    const {setTheme} = ThemeStore( (state)=>(
        {
            setTheme: state.setTheme,
        }
    ))
    const {
        data: practiceFrontTree,
        isLoading:practiceTreeLoading,
        error,
        status
    } = useQuery<any, any>([QUERY_NAMES.PRACTICE_FRONT_BY_DOMAIN], () => getPracticeFrontByDomain(subdomain?subdomain: ''), {
        enabled: !!subdomain,
        refetchOnWindowFocus: false,
        retry:0,
    });
    const {
        data: practiceFrontTreeStage,
        isLoading:practiceTreeLoadingStage,
        error:errorStage,
        status:statusStage
    } = useQuery<any, any>([QUERY_NAMES.PRACTICE_FRONT_BY_DOMAIN], () => getPracticeFrontByDomainStage(subdomain?subdomain: ''), {
        enabled: !!subDomainStage,
        refetchOnWindowFocus: false,
        retry:0,
    });

    useEffect(()=>{
        if(error)
              setSubDomainStage(subdomain)
    },[error, subdomain]);

    useEffect(()=>{
        if(practiceFrontTree?.response?.children && status==="success") {
            setTheme(prepareNodes(practiceFrontTree.response) as any)

            const siteSeoData={
                siteDescription: practiceFrontTree?.response?.practiceFrontData?.seoSettings?.siteDescription|| "Website",
                siteFavIcon: practiceFrontTree?.response?.practiceFrontData?.seoSettings?.siteFavIcon ||  '',
                siteKeywords: practiceFrontTree?.response?.practiceFrontData?.seoSettings?.siteKeywords ||   'Docspace,website',
                siteTitle: practiceFrontTree?.response?.practiceFrontData?.seoSettings?.siteTitle || "Landing",
            }
            setSeoSettings(siteSeoData)
        }
        else  if(practiceFrontTreeStage?.response?.children && status==="success") {
            setTheme(prepareNodes(practiceFrontTreeStage.response) as any)
            const siteSeoData={
                siteDescription: practiceFrontTreeStage?.response?.practiceFrontData?.seoSettings?.siteDescription|| "Website",
                siteFavIcon: practiceFrontTreeStage?.response?.practiceFrontData?.seoSettings?.siteFavIcon ||  '',
                siteKeywords: practiceFrontTreeStage?.response?.practiceFrontData?.seoSettings?.siteKeywords ||   'Docspace,website',
                siteTitle: practiceFrontTreeStage?.response?.practiceFrontData?.seoSettings?.siteTitle || "Landing",
            }
            setSeoSettings(siteSeoData)
        }

    },[setTheme, practiceFrontTree, practiceFrontTreeStage, status]);


    const handleHomeRoute=()=>{
        window.location.href='https://mydocspace.com';
    }

    if((practiceFrontTree && !practiceFrontTree.response) || error || errorStage){
        return (
            <PageError  title={'Sorry we could not find any website for this '}  subTitle={''} ctaButtonText={"Visit MydocSpace "}  onCTAClick={handleHomeRoute}/>
        )
    }


    if((practiceFrontTree && practiceFrontTree.response) || (practiceFrontTreeStage && practiceFrontTreeStage.response)) {
        return (
            <Fragment>
                <Head  seoSettings={seoSettings} subdomain={subdomain}/>
              <RendererEngine/>
            </Fragment>
        );
    }
    return  <PageLoader/>
};


const prepareNodes = (tree: PracticeFrontNode) => {
    try {
        tree.path = tree.path || [];
        delete (tree as any).__v;
    
        if (tree.children?.length){
            tree.children.forEach((node, index) => {
                node.path = [...(tree.path || [])];
                node.path.push(index);
                prepareNodes(node);
            })
        }
    }catch (e){
        console.error("Error in preparing nodes => ", e)
    }
    return tree;
}


export default AppContainer;
